





































import { Component, Prop, Vue } from "vue-property-decorator";
import CreateWorkingOnIssue from "@/components/editor/base/CreateWorkingOnIssue.vue";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { api } from "@/api";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";

@Component({
  components: { CreateWorkingOnIssue }
})
export default class WorkingOnIssuesList extends Vue {
  @Prop(String) readonly label!: string;
  issues = [];
  loading = true;
  expanded = [];

  issueHeaders = [
    { text: "ID", value: "iid" },
    { text: "Title", value: "title" },
    { text: "Created By", value: "author.name" },
    { text: "", value: "data-table-expand" }
  ];

  async mounted() {
    await this.loadIssues();
  }

  async loadIssues() {
    try {
      const gitLabInfo = readGitLabInfo(this.$store);
      this.issues = await api.getWorkingOnIssues(
        gitLabInfo.projectId,
        this.label
      );
      this.loading = false;
    } catch (e) {
      await dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Unable to fetch Issues:<br>${e}`)
      );
    }
  }
}
